export const enCountriesList = [
  {
    morningstarStandardizedName: "Mozambique",
    isoCountryCode: "MZ",
    name: "Mozambique",
  },
  {
    morningstarStandardizedName: "France",
    isoCountryCode: "FR",
    name: "France",
  },
  {
    morningstarStandardizedName: "Tonga",
    isoCountryCode: "TO",
    name: "Tonga",
  },
  {
    morningstarStandardizedName: "Ireland",
    isoCountryCode: "IE",
    name: "Ireland",
  },
  {
    morningstarStandardizedName: "Greece",
    isoCountryCode: "GR",
    name: "Greece",
  },
  {
    morningstarStandardizedName: "Peru",
    isoCountryCode: "PE",
    name: "Peru",
  },
  {
    morningstarStandardizedName: "Lithuania",
    isoCountryCode: "LT",
    name: "Lithuania",
  },
  {
    morningstarStandardizedName: "Qatar",
    isoCountryCode: "QA",
    name: "Qatar",
  },
  {
    morningstarStandardizedName: "Comoros",
    isoCountryCode: "KM",
    name: "Comoros",
  },
  {
    morningstarStandardizedName: "Myanmar",
    isoCountryCode: "MM",
    name: "Myanmar (Burma)",
  },
  {
    morningstarStandardizedName: "Senegal",
    isoCountryCode: "SN",
    name: "Senegal",
  },
  {
    morningstarStandardizedName: "Gambia",
    isoCountryCode: "GM",
    name: "Gambia",
  },
  {
    morningstarStandardizedName: "Andorra",
    isoCountryCode: "AD",
    name: "Andorra",
  },
  {
    morningstarStandardizedName: "Saint Kitts and Nevis",
    isoCountryCode: "KN",
    name: "St. Kitts & Nevis",
  },
  {
    morningstarStandardizedName: "Cambodia",
    isoCountryCode: "KH",
    name: "Cambodia",
  },
  {
    morningstarStandardizedName: "Thailand",
    isoCountryCode: "TH",
    name: "Thailand",
  },
  {
    morningstarStandardizedName: "Cayman Islands",
    isoCountryCode: "KY",
    name: "Cayman Islands",
  },
  {
    morningstarStandardizedName: "New Caledonia",
    isoCountryCode: "NC",
    name: "New Caledonia",
  },
  {
    morningstarStandardizedName: "Sint Maarten",
    isoCountryCode: "SX",
    name: "Sint Maarten",
  },
  {
    morningstarStandardizedName: "Suriname",
    isoCountryCode: "SR",
    name: "Suriname",
  },
  {
    morningstarStandardizedName: "Kosovo",
    isoCountryCode: "XK",
    name: "Kosovo",
  },
  {
    morningstarStandardizedName: "Kuwait",
    isoCountryCode: "KW",
    name: "Kuwait",
  },
  {
    morningstarStandardizedName: "Micronesia, Federated States of",
    isoCountryCode: "FM",
    name: "Micronesia",
  },
  {
    morningstarStandardizedName: "Jordan",
    isoCountryCode: "JO",
    name: "Jordan",
  },
  {
    morningstarStandardizedName: "Uganda",
    isoCountryCode: "UG",
    name: "Uganda",
  },
  {
    morningstarStandardizedName: "Singapore",
    isoCountryCode: "SG",
    name: "Singapore",
  },
  {
    morningstarStandardizedName: "Equatorial Guinea",
    isoCountryCode: "GQ",
    name: "Equatorial Guinea",
  },
  {
    morningstarStandardizedName: "Bosnia and Herzegovina",
    isoCountryCode: "BA",
    name: "Bosnia & Herzegovina",
  },
  {
    morningstarStandardizedName: "Tanzania, United Republic Of",
    isoCountryCode: "TZ",
    name: "Tanzania",
  },
  {
    morningstarStandardizedName: "New Zealand",
    isoCountryCode: "NZ",
    name: "New Zealand",
  },
  {
    morningstarStandardizedName: "Aruba",
    isoCountryCode: "AW",
    name: "Aruba",
  },
  {
    morningstarStandardizedName: "Macedonia, The Former Yugoslav Republic of",
    isoCountryCode: "MK",
    name: "North Macedonia",
  },
  {
    morningstarStandardizedName: "Togo",
    isoCountryCode: "TG",
    name: "Togo",
  },
  {
    morningstarStandardizedName: "Zimbabwe",
    isoCountryCode: "ZW",
    name: "Zimbabwe",
  },
  {
    morningstarStandardizedName: "Sri Lanka",
    isoCountryCode: "LK",
    name: "Sri Lanka",
  },
  {
    morningstarStandardizedName: "Malawi",
    isoCountryCode: "MW",
    name: "Malawi",
  },
  {
    morningstarStandardizedName: "Dominica",
    isoCountryCode: "DM",
    name: "Dominica",
  },
  {
    morningstarStandardizedName: "United Kingdom",
    isoCountryCode: "GB",
    name: "United Kingdom",
  },
  {
    morningstarStandardizedName: "Latvia",
    isoCountryCode: "LV",
    name: "Latvia",
  },
  {
    morningstarStandardizedName: "Bolivia",
    isoCountryCode: "BO",
    name: "Bolivia",
  },
  {
    morningstarStandardizedName: "Israel",
    isoCountryCode: "IL",
    name: "Israel",
  },
  {
    morningstarStandardizedName: "Congo, The Democratic Republic Of The",
    isoCountryCode: "CD",
    name: "Congo - Kinshasa",
  },
  {
    morningstarStandardizedName: "Belize",
    isoCountryCode: "BZ",
    name: "Belize",
  },
  {
    morningstarStandardizedName: "Mauritania",
    isoCountryCode: "MR",
    name: "Mauritania",
  },
  {
    morningstarStandardizedName: "Vanuatu",
    isoCountryCode: "VU",
    name: "Vanuatu",
  },
  {
    morningstarStandardizedName: "Vietnam",
    isoCountryCode: "VN",
    name: "Vietnam",
  },
  {
    morningstarStandardizedName: "Iceland",
    isoCountryCode: "IS",
    name: "Iceland",
  },
  {
    morningstarStandardizedName: "Montenegro",
    isoCountryCode: "ME",
    name: "Montenegro",
  },
  {
    morningstarStandardizedName: "Paraguay",
    isoCountryCode: "PY",
    name: "Paraguay",
  },
  {
    morningstarStandardizedName: "Fiji",
    isoCountryCode: "FJ",
    name: "Fiji",
  },
  {
    morningstarStandardizedName: "Brazil",
    isoCountryCode: "BR",
    name: "Brazil",
  },
  {
    morningstarStandardizedName: "Portugal",
    isoCountryCode: "PT",
    name: "Portugal",
  },
  {
    morningstarStandardizedName: "Cameroon",
    isoCountryCode: "CM",
    name: "Cameroon",
  },
  {
    morningstarStandardizedName: "Cuba",
    isoCountryCode: "CU",
    name: "Cuba",
  },
  {
    morningstarStandardizedName: "Oman",
    isoCountryCode: "OM",
    name: "Oman",
  },
  {
    morningstarStandardizedName: "Belgium",
    isoCountryCode: "BE",
    name: "Belgium",
  },
  {
    morningstarStandardizedName: "Morocco",
    isoCountryCode: "MA",
    name: "Morocco",
  },
  {
    morningstarStandardizedName: "Nauru",
    isoCountryCode: "NR",
    name: "Nauru",
  },
  {
    morningstarStandardizedName: "Niger",
    isoCountryCode: "NE",
    name: "Niger",
  },
  {
    morningstarStandardizedName: "Congo, Republic of the",
    isoCountryCode: "CG",
    name: "Congo - Brazzaville",
  },
  {
    morningstarStandardizedName: "Venezuela",
    isoCountryCode: "VE",
    name: "Venezuela",
  },
  {
    morningstarStandardizedName: "Gabon",
    isoCountryCode: "GA",
    name: "Gabon",
  },
  {
    morningstarStandardizedName: "Angola",
    isoCountryCode: "AO",
    name: "Angola",
  },
  {
    morningstarStandardizedName: "Slovenia",
    isoCountryCode: "SI",
    name: "Slovenia",
  },
  {
    morningstarStandardizedName: "Rwanda",
    isoCountryCode: "RW",
    name: "Rwanda",
  },
  {
    morningstarStandardizedName: "Sao Tome & Principe",
    isoCountryCode: "ST",
    name: "São Tomé & Príncipe",
  },
  {
    morningstarStandardizedName: "Cyprus",
    isoCountryCode: "CY",
    name: "Cyprus",
  },
  {
    morningstarStandardizedName: "United States of America",
    isoCountryCode: "US",
    name: "United States",
  },
  {
    morningstarStandardizedName: "Tuvalu",
    isoCountryCode: "TV",
    name: "Tuvalu",
  },
  {
    morningstarStandardizedName: "Chile",
    isoCountryCode: "CL",
    name: "Chile",
  },
  {
    morningstarStandardizedName: "United States",
    isoCountryCode: "US",
    name: "United States",
  },
  {
    morningstarStandardizedName: "Moldova, Republic of",
    isoCountryCode: "MD",
    name: "Moldova",
  },
  {
    morningstarStandardizedName: "Saudi Arabia",
    isoCountryCode: "SA",
    name: "Saudi Arabia",
  },
  {
    morningstarStandardizedName: "Nepal",
    isoCountryCode: "NP",
    name: "Nepal",
  },
  {
    morningstarStandardizedName: "Bahrain",
    isoCountryCode: "BH",
    name: "Bahrain",
  },
  {
    morningstarStandardizedName: "Viet Nam",
    isoCountryCode: "VN",
    name: "Vietnam",
  },
  {
    morningstarStandardizedName: "Slovakia",
    isoCountryCode: "SK",
    name: "Slovakia",
  },
  {
    morningstarStandardizedName: "Kazakhstan",
    isoCountryCode: "KZ",
    name: "Kazakhstan",
  },
  {
    morningstarStandardizedName: "Mali",
    isoCountryCode: "ML",
    name: "Mali",
  },
  {
    morningstarStandardizedName: "Uruguay",
    isoCountryCode: "UY",
    name: "Uruguay",
  },
  {
    morningstarStandardizedName: "Indonesia",
    isoCountryCode: "ID",
    name: "Indonesia",
  },
  {
    morningstarStandardizedName: "China",
    isoCountryCode: "CN",
    name: "China",
  },
  {
    morningstarStandardizedName: "Guinea-Bissau",
    isoCountryCode: "GW",
    name: "Guinea-Bissau",
  },
  {
    morningstarStandardizedName: "Marshall Islands",
    isoCountryCode: "MH",
    name: "Marshall Islands",
  },
  {
    morningstarStandardizedName: "Kenya",
    isoCountryCode: "KE",
    name: "Kenya",
  },
  {
    morningstarStandardizedName: "Syrian Arab Republic",
    isoCountryCode: "SY",
    name: "Syria",
  },
  {
    morningstarStandardizedName: "US",
    isoCountryCode: "US",
    name: "United States",
  },
  {
    morningstarStandardizedName: "South Sudan",
    isoCountryCode: "SS",
    name: "South Sudan",
  },
  {
    morningstarStandardizedName: "Croatia",
    isoCountryCode: "HR",
    name: "Croatia",
  },
  {
    morningstarStandardizedName: "Albania",
    isoCountryCode: "AL",
    name: "Albania",
  },
  {
    morningstarStandardizedName: "Jamaica",
    isoCountryCode: "JM",
    name: "Jamaica",
  },
  {
    morningstarStandardizedName: "Denmark",
    isoCountryCode: "DK",
    name: "Denmark",
  },
  {
    morningstarStandardizedName: "Antigua and Barbuda",
    isoCountryCode: "AG",
    name: "Antigua & Barbuda",
  },
  {
    morningstarStandardizedName: "Nicaragua",
    isoCountryCode: "NI",
    name: "Nicaragua",
  },
  {
    morningstarStandardizedName: "Libyan Arab Jamahiriya",
    isoCountryCode: "LY",
    name: "Libya",
  },
  {
    morningstarStandardizedName: "Burundi",
    isoCountryCode: "BI",
    name: "Burundi",
  },
  {
    morningstarStandardizedName: "Bermuda",
    isoCountryCode: "BM",
    name: "Bermuda",
  },
  {
    morningstarStandardizedName: "Italy",
    isoCountryCode: "IT",
    name: "Italy",
  },
  {
    morningstarStandardizedName: "Puerto Rico",
    isoCountryCode: "PR",
    name: "Puerto Rico",
  },
  {
    morningstarStandardizedName: "Chad",
    isoCountryCode: "TD",
    name: "Chad",
  },
  {
    morningstarStandardizedName: "Turkmenistan",
    isoCountryCode: "TM",
    name: "Turkmenistan",
  },
  {
    morningstarStandardizedName: "Haiti",
    isoCountryCode: "HT",
    name: "Haiti",
  },
  {
    morningstarStandardizedName: "Benin",
    isoCountryCode: "BJ",
    name: "Benin",
  },
  {
    morningstarStandardizedName: "Macao",
    isoCountryCode: "MO",
    name: "Macao SAR China",
  },
  {
    morningstarStandardizedName: "Germany",
    isoCountryCode: "DE",
    name: "Germany",
  },
  {
    morningstarStandardizedName: "Romania",
    isoCountryCode: "RO",
    name: "Romania",
  },
  {
    morningstarStandardizedName: "Malaysia",
    isoCountryCode: "MY",
    name: "Malaysia",
  },
  {
    morningstarStandardizedName: "Palestinian Territory, Occupied",
    isoCountryCode: "PS",
    name: "Palestinian Territories",
  },
  {
    morningstarStandardizedName: "Ethiopia",
    isoCountryCode: "ET",
    name: "Ethiopia",
  },
  {
    morningstarStandardizedName: "Bhutan",
    isoCountryCode: "BT",
    name: "Bhutan",
  },
  {
    morningstarStandardizedName: "Guyana",
    isoCountryCode: "GY",
    name: "Guyana",
  },
  {
    morningstarStandardizedName: "Saint Lucia",
    isoCountryCode: "LC",
    name: "St. Lucia",
  },
  {
    morningstarStandardizedName: "Djibouti",
    isoCountryCode: "DJ",
    name: "Djibouti",
  },
  {
    morningstarStandardizedName: "Swaziland",
    isoCountryCode: "SZ",
    name: "Eswatini",
  },
  {
    morningstarStandardizedName: "Liberia",
    isoCountryCode: "LR",
    name: "Liberia",
  },
  {
    morningstarStandardizedName: "Cape Verde",
    isoCountryCode: "CV",
    name: "Cape Verde",
  },
  {
    morningstarStandardizedName: "Azerbaijan",
    isoCountryCode: "AZ",
    name: "Azerbaijan",
  },
  {
    morningstarStandardizedName: "Switzerland",
    isoCountryCode: "CH",
    name: "Switzerland",
  },
  {
    morningstarStandardizedName: "China, People's Republic of",
    isoCountryCode: "CN",
    name: "China",
  },
  {
    morningstarStandardizedName: "Papua New Guinea",
    isoCountryCode: "PG",
    name: "Papua New Guinea",
  },
  {
    morningstarStandardizedName: "Algeria",
    isoCountryCode: "DZ",
    name: "Algeria",
  },
  {
    morningstarStandardizedName: "Yemen",
    isoCountryCode: "YE",
    name: "Yemen",
  },
  {
    morningstarStandardizedName: "Luxembourg",
    isoCountryCode: "LU",
    name: "Luxembourg",
  },
  {
    morningstarStandardizedName: "Norway",
    isoCountryCode: "NO",
    name: "Norway",
  },
  {
    morningstarStandardizedName: "Nigeria",
    isoCountryCode: "NG",
    name: "Nigeria",
  },
  {
    morningstarStandardizedName: "American Samoa",
    isoCountryCode: "AS",
    name: "American Samoa",
  },
  {
    morningstarStandardizedName: "Saint Vincent and the Grenadines",
    isoCountryCode: "VC",
    name: "St. Vincent & Grenadines",
  },
  {
    morningstarStandardizedName: "India",
    isoCountryCode: "IN",
    name: "India",
  },
  {
    morningstarStandardizedName: "Palau",
    isoCountryCode: "PW",
    name: "Palau",
  },
  {
    morningstarStandardizedName: "Tunisia",
    isoCountryCode: "TN",
    name: "Tunisia",
  },
  {
    morningstarStandardizedName: "Bangladesh",
    isoCountryCode: "BD",
    name: "Bangladesh",
  },
  {
    morningstarStandardizedName: "French Polynesia",
    isoCountryCode: "PF",
    name: "French Polynesia",
  },
  {
    morningstarStandardizedName: "Sierra Leone",
    isoCountryCode: "SL",
    name: "Sierra Leone",
  },
  {
    morningstarStandardizedName: "Burkina Faso",
    isoCountryCode: "BF",
    name: "Burkina Faso",
  },
  {
    morningstarStandardizedName: "Japan",
    isoCountryCode: "JP",
    name: "Japan",
  },
  {
    morningstarStandardizedName: "Trinidad and Tobago",
    isoCountryCode: "TT",
    name: "Trinidad & Tobago",
  },
  {
    morningstarStandardizedName: "Ecuador",
    isoCountryCode: "EC",
    name: "Ecuador",
  },
  {
    morningstarStandardizedName: "Panama",
    isoCountryCode: "PA",
    name: "Panama",
  },
  {
    morningstarStandardizedName: "Ghana",
    isoCountryCode: "GH",
    name: "Ghana",
  },
  {
    morningstarStandardizedName: "Pakistan",
    isoCountryCode: "PK",
    name: "Pakistan",
  },
  {
    morningstarStandardizedName: "Bulgaria",
    isoCountryCode: "BG",
    name: "Bulgaria",
  },
  {
    morningstarStandardizedName: "Seychelles",
    isoCountryCode: "SC",
    name: "Seychelles",
  },
  {
    morningstarStandardizedName: "Malta",
    isoCountryCode: "MT",
    name: "Malta",
  },
  {
    morningstarStandardizedName: "UK",
    isoCountryCode: "GB",
    name: "United Kingdom",
  },
  {
    morningstarStandardizedName: "Iraq",
    isoCountryCode: "IQ",
    name: "Iraq",
  },
  {
    morningstarStandardizedName: "People’s Republic of China",
    isoCountryCode: "CN",
    name: "China",
  },
  {
    morningstarStandardizedName: "Curaçao",
    isoCountryCode: "CW",
    name: "Curaçao",
  },
  {
    morningstarStandardizedName: "Virgin Islands, U.S.",
    isoCountryCode: "VI",
    name: "U.S. Virgin Islands",
  },
  {
    morningstarStandardizedName: "Sweden",
    isoCountryCode: "SE",
    name: "Sweden",
  },
  {
    morningstarStandardizedName: "United Arab Emirates",
    isoCountryCode: "AE",
    name: "United Arab Emirates",
  },
  {
    morningstarStandardizedName: "Eritrea",
    isoCountryCode: "ER",
    name: "Eritrea",
  },
  {
    morningstarStandardizedName: "Spain",
    isoCountryCode: "ES",
    name: "Spain",
  },
  {
    morningstarStandardizedName: "Guinea",
    isoCountryCode: "GN",
    name: "Guinea",
  },
  {
    morningstarStandardizedName: "Hong Kong",
    isoCountryCode: "HK",
    name: "Hong Kong SAR China",
  },
  {
    morningstarStandardizedName: "Isle of Man",
    isoCountryCode: "IM",
    name: "Isle of Man",
  },
  {
    morningstarStandardizedName: "Argentina",
    isoCountryCode: "AR",
    name: "Argentina",
  },
  {
    morningstarStandardizedName: "Dominican Republic",
    isoCountryCode: "DO",
    name: "Dominican Republic",
  },
  {
    morningstarStandardizedName: "Zambia",
    isoCountryCode: "ZM",
    name: "Zambia",
  },
  {
    morningstarStandardizedName: "Austria",
    isoCountryCode: "AT",
    name: "Austria",
  },
  {
    morningstarStandardizedName: "Australia",
    isoCountryCode: "AU",
    name: "Australia",
  },
  {
    morningstarStandardizedName: "Kiribati",
    isoCountryCode: "KI",
    name: "Kiribati",
  },
  {
    morningstarStandardizedName: "Grenada",
    isoCountryCode: "GD",
    name: "Grenada",
  },
  {
    morningstarStandardizedName: "Kyrgyzstan",
    isoCountryCode: "KG",
    name: "Kyrgyzstan",
  },
  {
    morningstarStandardizedName: "Madagascar",
    isoCountryCode: "MG",
    name: "Madagascar",
  },
  {
    morningstarStandardizedName: "Egypt",
    isoCountryCode: "EG",
    name: "Egypt",
  },
  {
    morningstarStandardizedName: "Korea, Republic of",
    isoCountryCode: "KR",
    name: "South Korea",
  },
  {
    morningstarStandardizedName: "Brunei Darussalam",
    isoCountryCode: "BN",
    name: "Brunei",
  },
  {
    morningstarStandardizedName: "Ukraine",
    isoCountryCode: "UA",
    name: "Ukraine",
  },
  {
    morningstarStandardizedName: "Bahamas",
    isoCountryCode: "BS",
    name: "Bahamas",
  },
  {
    morningstarStandardizedName: "Samoa",
    isoCountryCode: "WS",
    name: "Samoa",
  },
  {
    morningstarStandardizedName: "Armenia",
    isoCountryCode: "AM",
    name: "Armenia",
  },
  {
    morningstarStandardizedName: "Côte d'Ivoire",
    isoCountryCode: "CI",
    name: "Côte d’Ivoire",
  },
  {
    morningstarStandardizedName: "Georgia",
    isoCountryCode: "GE",
    name: "Georgia",
  },
  {
    morningstarStandardizedName: "Lao People's Democratic Republic",
    isoCountryCode: "LA",
    name: "Laos",
  },
  {
    morningstarStandardizedName: "Taiwan",
    isoCountryCode: "TW",
    name: "Taiwan",
  },
  {
    morningstarStandardizedName: "Russian Federation",
    isoCountryCode: "RU",
    name: "Russia",
  },
  {
    morningstarStandardizedName: "Finland",
    isoCountryCode: "FI",
    name: "Finland",
  },
  {
    morningstarStandardizedName: "Afghanistan",
    isoCountryCode: "AF",
    name: "Afghanistan",
  },
  {
    morningstarStandardizedName: "Faroe Islands",
    isoCountryCode: "FO",
    name: "Faroe Islands",
  },
  {
    morningstarStandardizedName: "Jersey",
    isoCountryCode: "JE",
    name: "Jersey",
  },
  {
    morningstarStandardizedName: "Mexico",
    isoCountryCode: "MX",
    name: "Mexico",
  },
  {
    morningstarStandardizedName: "Tajikistan",
    isoCountryCode: "TJ",
    name: "Tajikistan",
  },
  {
    morningstarStandardizedName: "Botswana",
    isoCountryCode: "BW",
    name: "Botswana",
  },
  {
    morningstarStandardizedName: "Korea, Democratic People's Republic of",
    isoCountryCode: "KP",
    name: "North Korea",
  },
  {
    morningstarStandardizedName: "Czech Republic",
    isoCountryCode: "CZ",
    name: "Czechia",
  },
  {
    morningstarStandardizedName: "Canada",
    isoCountryCode: "CA",
    name: "Canada",
  },
  {
    morningstarStandardizedName: "Greenland",
    isoCountryCode: "GL",
    name: "Greenland",
  },
  {
    morningstarStandardizedName: "Mauritius",
    isoCountryCode: "MU",
    name: "Mauritius",
  },
  {
    morningstarStandardizedName: "Liechtenstein",
    isoCountryCode: "LI",
    name: "Liechtenstein",
  },
  {
    morningstarStandardizedName: "Honduras",
    isoCountryCode: "HN",
    name: "Honduras",
  },
  {
    morningstarStandardizedName: "Sudan",
    isoCountryCode: "SD",
    name: "Sudan",
  },
  {
    morningstarStandardizedName: "Philippines",
    isoCountryCode: "PH",
    name: "Philippines",
  },
  {
    morningstarStandardizedName: "Netherlands",
    isoCountryCode: "NL",
    name: "Netherlands",
  },
  {
    morningstarStandardizedName: "Belarus",
    isoCountryCode: "BY",
    name: "Belarus",
  },
  {
    morningstarStandardizedName: "Poland",
    isoCountryCode: "PL",
    name: "Poland",
  },
  {
    morningstarStandardizedName: "Mongolia",
    isoCountryCode: "MN",
    name: "Mongolia",
  },
  {
    morningstarStandardizedName: "Monaco",
    isoCountryCode: "MC",
    name: "Monaco",
  },
  {
    morningstarStandardizedName: "Guatemala",
    isoCountryCode: "GT",
    name: "Guatemala",
  },
  {
    morningstarStandardizedName: "Iran, Islamic Republic of",
    isoCountryCode: "IR",
    name: "Iran",
  },
  {
    morningstarStandardizedName: "Uzbekistan",
    isoCountryCode: "UZ",
    name: "Uzbekistan",
  },
  {
    morningstarStandardizedName: "Namibia",
    isoCountryCode: "NA",
    name: "Namibia",
  },
  {
    morningstarStandardizedName: "Solomon Islands",
    isoCountryCode: "SB",
    name: "Solomon Islands",
  },
  {
    morningstarStandardizedName: "El Salvador",
    isoCountryCode: "SV",
    name: "El Salvador",
  },
  {
    morningstarStandardizedName: "Hungary",
    isoCountryCode: "HU",
    name: "Hungary",
  },
  {
    morningstarStandardizedName: "Estonia",
    isoCountryCode: "EE",
    name: "Estonia",
  },
  {
    morningstarStandardizedName: "Guam",
    isoCountryCode: "GU",
    name: "Guam",
  },
  {
    morningstarStandardizedName: "Maldives",
    isoCountryCode: "MV",
    name: "Maldives",
  },
  {
    morningstarStandardizedName: "Somalia",
    isoCountryCode: "SO",
    name: "Somalia",
  },
  {
    morningstarStandardizedName: "Northern Mariana Islands",
    isoCountryCode: "MP",
    name: "Northern Mariana Islands",
  },
  {
    morningstarStandardizedName: "Russia",
    isoCountryCode: "RU",
    name: "Russia",
  },
  {
    morningstarStandardizedName: "South Africa",
    isoCountryCode: "ZA",
    name: "South Africa",
  },
  {
    morningstarStandardizedName: "Lesotho",
    isoCountryCode: "LS",
    name: "Lesotho",
  },
];
